/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Aggregated tool usage metrics for one MCP client
 */
export type ToolUsageClientSummary = {
  /**
   * Stable MCP client identity used by filters and chart grouping
   */
  clientKey: string;
  /**
   * User-facing label for the MCP client
   */
  clientLabel: string;
  /**
   * Total number of tool usage events for the MCP client
   */
  eventCount: number;
  /**
   * Number of failed tool usage events for the MCP client
   */
  failureCount: number;
  /**
   * Fraction of completed tool usage events for the MCP client that failed
   */
  failureRate: number;
  /**
   * Number of successful tool usage events for the MCP client
   */
  successCount: number;
  /**
   * Number of distinct tools observed for the MCP client
   */
  uniqueTools: number;
};

/** @internal */
export const ToolUsageClientSummary$inboundSchema: z.ZodMiniType<
  ToolUsageClientSummary,
  unknown
> = z.pipe(
  z.object({
    client_key: z.string(),
    client_label: z.string(),
    event_count: z.int(),
    failure_count: z.int(),
    failure_rate: z.number(),
    success_count: z.int(),
    unique_tools: z.int(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "client_key": "clientKey",
      "client_label": "clientLabel",
      "event_count": "eventCount",
      "failure_count": "failureCount",
      "failure_rate": "failureRate",
      "success_count": "successCount",
      "unique_tools": "uniqueTools",
    });
  }),
);

export function toolUsageClientSummaryFromJSON(
  jsonString: string,
): SafeParseResult<ToolUsageClientSummary, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ToolUsageClientSummary$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ToolUsageClientSummary' from JSON`,
  );
}
